const MS_IN_DAY = 24 * 60 * 60 * 1000;
const MONTHS = 3 * 30;

const setNotificationCookie = name => {
  const date = new Date();
  date.setTime(date.getTime() + MONTHS * MS_IN_DAY);
  document.cookie = `notificationBanner_${name}=true; expires="${date.toUTCString()}"; path=/`;
};

export default setNotificationCookie;
